
import Card from '@/components/material/Card.vue';
import DlgGuestImportCSV from '@/modules/admin/guests/_components/DlgGuestImportCSV.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component({
             components: {Card, DlgGuestImportCSV},
           })
export default class VGroupList extends Vue {
  @Prop({default: ''}) private readonly id!: string;

  @Action('admin/groups/readOne') private readOne!: any;
  @Action('admin/guests/read') private readGuests!: any;

  @Action('admin/groups/update') private update!: any;

  @Getter('admin/groups/one') private group!: any;
  @Getter('admin/guests/all') private guests!: any;

  private loading: boolean = false;
  private groupTitle: string = '';
  private members: any = [];

  private headers: any = [
    {
      text: 'Unternehmen',
      align: 'left',
      value: 'company',
    },
    {
      text: 'Vorname',
      align: 'left',
      value: 'forename',
    },
    {
      text: 'Nachname',
      align: 'left',
      value: 'surname',
    },
    {
      text: 'Email',
      align: 'left',
      value: 'email',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  private mounted() {
    this.init();
  }

  private async init() {
    this.loading = true;
    await this.readOne({id: this.id});
    await this.readGuests();

    this.members = this.group.members.map((member) => member.guestId);
    this.groupTitle = this.group.title;
    this.loading = false;
  }

  private removeMember(item) {
    const index = this.members.indexOf(item);
    this.members.splice(index, 1);
  }

  private async save() {
    this.loading = true;
    await this.update({id: this.group.id, title: this.groupTitle, members: this.members});
    this.loading = false;

    this.init();
  }

  public async onGuestsImported(result) {
    // Refresh guest list so new guests appear in autocomplete
    await this.readGuests();

    const notes: string[] = [];
    const allItems = [...(result.created || []), ...(result.existing || [])];

    // Add imported guest IDs to the group members (skip duplicates)
    for (const guest of allItems) {
      if (guest && guest.id && !this.members.includes(guest.id)) {
        this.members.push(guest.id);
      }
    }

    if (result.existing && result.existing.length > 0) {
      const names = result.existing.map((g) => g.email).join(', ');
      notes.push(`${result.existing.length} Gast/Gäste existierten bereits: ${names}`);
    }
    if (result.created && result.created.length > 0) {
      notes.push(`${result.created.length} neue(r) Gast/Gäste erstellt.`);
    }
    if (notes.length) {
      alert(notes.join('\n'));
    }
  }

  // computed
  get changed() {
    return this.group.title !== this.groupTitle || this.group.members !== this.members;
  }

  get parsedMembers() {
    const members: any[] = [];
    this.members.forEach((memberId) => {
      this.guests.some((guest) => {
        if (guest.id === memberId) {
          members.push(guest);
          return true;
        }
      });
    });
    return members;
  }
}
